/**
 * "Document model" do template Manutenção Preventiva FM-200 — mesma fonte de
 * dados usada por `sections/Content.js` (PDF), extraída para um array de
 * blocos tipados e independente de React/JSX, consumido por
 * `_shared/generateDocx.js` para gerar o .docx.
 *
 * Mantém os mesmos IDs de pergunta, textos e ordem de seções de `Content.js` —
 * ver esse arquivo para a fonte da verdade caso os dois um dia divirjam.
 */
import { findReplyByQuestionId } from '../../_helpers/pdfHelpers'
import { questionBlocks } from '../../_shared/blockHelpers'
import { MONTHS } from '../../constants/dates'

export const buildDocumentModel = serviceOrder => {
  const { replies, endDate } = serviceOrder || {}

  const question302 = findReplyByQuestionId(replies, 302)
  const question303 = findReplyByQuestionId(replies, 303)
  const question304 = findReplyByQuestionId(replies, 304)
  const question311 = findReplyByQuestionId(replies, 311)
  const question312 = findReplyByQuestionId(replies, 312)
  const question342 = findReplyByQuestionId(replies, 342)
  const question315 = findReplyByQuestionId(replies, 315)
  const question316 = findReplyByQuestionId(replies, 316)
  const question318 = findReplyByQuestionId(replies, 318)
  const question319 = findReplyByQuestionId(replies, 319)
  const question320 = findReplyByQuestionId(replies, 320)
  const question321 = findReplyByQuestionId(replies, 321)
  const question322 = findReplyByQuestionId(replies, 322)
  const question323 = findReplyByQuestionId(replies, 323)
  const question326 = findReplyByQuestionId(replies, 326)
  const question327 = findReplyByQuestionId(replies, 327)
  const question328 = findReplyByQuestionId(replies, 328)
  const question329 = findReplyByQuestionId(replies, 329)
  const question332 = findReplyByQuestionId(replies, 332)
  const question333 = findReplyByQuestionId(replies, 333)
  const question334 = findReplyByQuestionId(replies, 334)
  const question335 = findReplyByQuestionId(replies, 335)
  const question336 = findReplyByQuestionId(replies, 336)
  const question338 = findReplyByQuestionId(replies, 338)
  const question353 = findReplyByQuestionId(replies, 353)
  const question354 = findReplyByQuestionId(replies, 354)
  const question355 = findReplyByQuestionId(replies, 355)

  const currentMonth = new Date(endDate).getMonth()
  const currentYear = new Date(endDate).getFullYear()

  const blocks = [
    {
      type: 'coverPage',
      lines: ['SABIC CENTRAL FM-200', 'MANUTENÇÃO PREVENTIVA', `${MONTHS[currentMonth]?.toUpperCase()} - ${currentYear}`]
    },
    { type: 'pageBreak' },
    { type: 'toc' },
    { type: 'pageBreak' },

    { type: 'heading', level: 1, text: '1. Introdução' },
    {
      type: 'paragraph',
      text: 'Este Relatório tem como objetivo expressar as atividades realizadas pela empresa Easy Solutions, bem como teste nos dispositivos do sistema de combate FM-200, visando informar sempre as melhorias cabíveis ao sistema de acordo com a necessidade de cada cliente e atender a NBR 17240-2010 (Sistema de Detecção e Alarme de Incêndio, Projetos, Instalações e Manutenções do Sistema).'
    },

    { type: 'heading', level: 1, text: '2. Serviços Realizados', pageBreakBefore: true },
    ...questionBlocks(question302),
    ...questionBlocks(question303),
    ...questionBlocks(question304),
    ...questionBlocks(question311),
    ...questionBlocks(question312),

    { type: 'heading', level: 1, text: '3. Tensões da central', pageBreakBefore: true },
    ...(question342?.question?.name
      ? [{ type: 'keyValue', label: question342.question.name, value: Array.isArray(question342?.value) ? '' : question342?.value ?? 'N/A' }]
      : []),

    { type: 'heading', level: 1, text: '4. Teste do Sistema', pageBreakBefore: true },
    ...questionBlocks(question315),
    ...questionBlocks(question316),
    ...questionBlocks(question318),
    ...questionBlocks(question319),
    ...questionBlocks(question320),
    ...questionBlocks(question321),
    ...questionBlocks(question322),
    ...questionBlocks(question323),
    ...questionBlocks(question326),
    ...questionBlocks(question327),
    ...questionBlocks(question328),
    ...questionBlocks(question329),
    ...questionBlocks(question332),
    ...questionBlocks(question333),
    ...questionBlocks(question334),
    ...questionBlocks(question335),
    ...questionBlocks(question336),
    ...questionBlocks(question338),

    { type: 'heading', level: 1, text: '5. Sistema ao sair', pageBreakBefore: true },
    ...questionBlocks(question353),
    ...questionBlocks(question354),

    { type: 'heading', level: 1, text: '6. Conclusão', pageBreakBefore: true },
    ...questionBlocks(question355)
  ]

  return {
    title: `SABIC CENTRAL FM-200 - Manutenção Preventiva - ${MONTHS[currentMonth]} ${currentYear}`,
    blocks
  }
}

export default buildDocumentModel
